// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__1ZU9M","dot":"styles_dot__SfP0v"};